import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { signOut } from "../../auth";
import "./Ops.css";

export default function OpsLayout() {
  const navigate = useNavigate();

  const handleSignOut = () => {
    signOut();
    navigate("/login", { replace: true });
  };

  return (
    <>
      <header className="ops-topbar">
        <span className="ops-topbar-brand">Tagnize Ops</span>
        <button type="button" className="ops-btn secondary" onClick={handleSignOut}>
          Cerrar sesión
        </button>
      </header>
      <div className="ops-page">
        <h1>Operaciones</h1>
        <p className="ops-subtitle">
          Backoffice interno (SPEC-24 FASE1). Acceso restringido a PlatformAdmin.
        </p>
        <nav className="ops-nav">
          <NavLink to="/" end>
            Inicio
          </NavLink>
          <NavLink to="/tenants">Tenants</NavLink>
          <NavLink to="/planes">Planes</NavLink>
          <NavLink to="/legal">T&amp;C</NavLink>
        </nav>
        <Outlet />
      </div>
    </>
  );
}
